import { DnaInfoComboBoxComponent } from './dna-info-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';


/**
 * DNA情報コンボボックスモデル
 *
 * @export DnaInfoComboBoxModel
 * @class DnaInfoComboBoxModel
 */
export class DnaInfoComboBoxModel {

  /**
   * ＤＮＡ区分マスタリスト
   */
  public codeList = [];

  public blank: boolean = <boolean>true;                                        // 先頭空白表示

  public component: DnaInfoComboBoxComponent;
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setCodeValue: string = <string>'';                                     // 初期設定コード値

  public codeDiv: string = <string>'';                                          // コード分類
  public reserveNum1: string = <string>'';                                      // 補助条件(比較フェーズ)
  public reserve1: string = <string>'';                                         // 予備１


  /**
	* ＤＮＡ区分マスタリスト更新する
	*
	* @param serverData DNA情報リストのサーバ取得データ
	*/
  updateCodeList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject('', ''));
      index = index + 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].DnaDivName = tempDataList[index].DnaDiv + ':' + tempDataList[index].DnaName;
    }

    this.codeList = tempDataList;

    this.completeUpdateFlg = true;

    // 選択コードが設定されたら優先する
    if (PlessViewUtilsSub.isEmpty(this.setCodeValue)) {
      this.setCodeValue = this.codeList[0].DnaDiv;
    }
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @param {string} codeValue
   * @param {string} codeName
   * @returns {object}
   * @memberof DnaInfoComboBoxModel
   */
  private getBlankObject(codeValue: string, codeName: string): object {
    const ob: any = new Object();

    ob.DnaDiv = codeValue;
    ob.DnaName = codeName;
    ob.SortNum = '';
    ob.OutputDiv = '';
    if (!PlessViewUtilsSub.isEmpty(codeValue) && !PlessViewUtilsSub.isEmpty(codeName)) {
      ob.DnaDivName = codeValue + ':' + codeName;
    } else {
      ob.DnaDivName = codeValue + codeName;
    }
    return ob;
  }

}
